// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list__M0n5r","normal":"List_normal__xKvzW","showMoreButton":"List_showMoreButton__DUc_9","small":"List_small__neZgr","large":"List_large__90eQe"};